<div
  class="nav-item"
  [class.nav-item--active]="activeItem"
  [class.hover]="hoverItem"
  *ngIf="typeItem !== 'back'"
>
  <div
    class="nav-item-border"
    [class.hover-div]="hoverItem"
    [class.active]="activeItem"
  ></div>

  <div class="ml">
    <slot name="icon" (slotchange)="slotChange($event)"></slot>

    <app-text
      [text]="title"
      type="span"
      [colorClass]="colorText"
      [fontSize]="14"
      [lineHeight]="20"
      fontWeight="700"
      [customStyles]="{ fontStyle: 'normal', letterSpacing: '0.02em' }"
      [class.ml]="marginLeft"
    ></app-text>
  </div>
</div>
<a class="nav-item-back" *ngIf="typeItem === 'back'" (click)="onClickBack()">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    class="feather feather-chevron-left nav-item-back__icon"
  >
    <polyline points="15 18 9 12 15 6"></polyline>
  </svg>
</a>
